import { render, staticRenderFns } from "./SidebarNew.vue?vue&type=template&id=3da128fa&"
import script from "./SidebarNew.vue?vue&type=script&lang=js&"
export * from "./SidebarNew.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports